import {useMemo} from 'react';

import {useActiveHistoryKeyInfo} from '../../../state/panelGenHistoryKeys/useActiveHistoryKeyInfo';
import {type KeyTypes} from '../common';
import {getMediaKeys} from '../utils/getMediaKeys';

export const useMediaKeys = (): {
  allMediaKeys: string[];
  defaultKeys: string[] | undefined;
  keyTypes: KeyTypes;
  numericKeys: string[];
} => {
  const {historyKeyInfo: keyInfo} = useActiveHistoryKeyInfo();

  const mediaKeysOptions = useMemo(() => getMediaKeys(keyInfo), [keyInfo]);

  return mediaKeysOptions;
};
